export default __webpack_public_path__ + "static/media/logo-text.95c537e8.png";